import IconEnFlag from '../common/icons/IconEnFlag';
import IconFrFlag from '../common/icons/IconFrFlag';
import IconNlFlag from '../common/icons/IconNlFlag';

export const languageConfig = {
  fr: {
    label: 'Version française',
    Icon: IconFrFlag,
  },
  en: {
    label: 'English version',
    Icon: IconEnFlag,
  },
  nl: {
    label: 'Nederlandse versie',
    Icon: IconNlFlag,
  },
}; 